// extracted by mini-css-extract-plugin
export default {"items":"Documentos_items__BcUUI","cardItem":"Documentos_cardItem__cMFVN","contatos":"Documentos_contatos__XRyQQ"};